module.exports = __webpack_public_path__ + "img/Klipsu-I.8f9852f5.png";